import { render, staticRenderFns } from "./TabletCharacters.vue?vue&type=template&id=a72e93b4&scoped=true&"
import script from "./TabletCharacters.vue?vue&type=script&lang=js&"
export * from "./TabletCharacters.vue?vue&type=script&lang=js&"
import style0 from "./TabletCharacters.vue?vue&type=style&index=0&id=a72e93b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a72e93b4",
  null
  
)

export default component.exports